import { useEffect, useState } from "react";

const MOBILE_SIDEBAR_WIDTH_VW_DEFAULT = 90;
const MOBILE_SIDEBAR_WIDTH_VW_SMALL = 100;
const SMALL_PHONE_BREAKPOINT = 375;

export const useMobileSidebarWidth = () => {
    const [width, setWidth] = useState(() =>
        typeof window !== "undefined" && window.innerWidth < SMALL_PHONE_BREAKPOINT
            ? MOBILE_SIDEBAR_WIDTH_VW_SMALL
            : MOBILE_SIDEBAR_WIDTH_VW_DEFAULT,
    );

    useEffect(() => {
        const handleResize = () => {
            setWidth(
                window.innerWidth < SMALL_PHONE_BREAKPOINT
                    ? MOBILE_SIDEBAR_WIDTH_VW_SMALL
                    : MOBILE_SIDEBAR_WIDTH_VW_DEFAULT,
            );
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return width;
};

export const MOBILE_SIDEBAR_WIDTH_VW = MOBILE_SIDEBAR_WIDTH_VW_DEFAULT;
